import { Button, Flex, Paper, Text, Title } from "@mantine/core";

interface SigningCompleteProps {
  title?: string;
  description?: string;
  showCloseButton?: boolean;
}

export function SigningComplete({
  title = "Signering klar!",
  description = "Du har signerat fullmakten. Återgå till din ursprungliga flik där processen slutförs. Du kan stänga den här fliken.",
  showCloseButton = true,
}: SigningCompleteProps) {
  return (
    <Flex justify="center" align="center" px="xl">
      <Flex direction="column" maw={672} w="100%">
        <Paper p={30} radius="24px" mt="xl">
          <Title order={3} mb="md" ff="var(--wallet-font-family-sambla-sans)">
            {title}
          </Title>
          <Text>{description}</Text>
          {showCloseButton && (
            <>
              <Button mt="md" fullWidth onClick={() => window.close()}>
                Stäng fliken
              </Button>
              <Text size="sm" c="dimmed" ta="center" mt="xs">
                Om fliken inte stängs automatiskt kan din webbläsare blockera
                detta. Stäng fliken manuellt i så fall.
              </Text>
            </>
          )}
        </Paper>
      </Flex>
    </Flex>
  );
}
